export default "__VITE_ASSET__DMDztPd7__"